import { shallowEqual } from 'react-redux';

import { AppState, useAppSelector } from '@redux/store';

export const useShowDataById = (id = '') =>
  useAppSelector(({ shows }: AppState) => shows.byId[id] ?? {}, shallowEqual);

export const useCurrentShowId = () =>
  useAppSelector(({ shows }: AppState) => shows.currentShowId ?? '');

export const useCurrentRecordedShowId = () =>
  useAppSelector(({ shows }: AppState) => shows.currentRecordedShowId);

export const useMyTeamSuggestedShows = () =>
  useAppSelector(
    ({ feed }: AppState) => feed.suggested?.live?.myTeam?.ids || [],
    shallowEqual,
  );

export const useMayLoadMoreMyTeamSuggested = () =>
  useAppSelector(({ feed }: AppState) =>
    feed.suggested?.live?.myTeam?.mayLoadMore !== undefined
      ? feed.suggested?.live?.myTeam?.mayLoadMore
      : true,
  );

export const useNonMyTeamSuggestedShows = () =>
  useAppSelector(
    ({ feed }: AppState) => feed.suggested?.live?.nonMyTeam?.ids || [],
    shallowEqual,
  );

export const useMayLoadMoreNonMyTeamSuggested = () =>
  useAppSelector(({ feed }: AppState) =>
    feed.suggested?.live?.nonMyTeam?.mayLoadMore !== undefined
      ? feed.suggested?.live?.nonMyTeam?.mayLoadMore
      : true,
  );

export const useSuggestedRecordedShows = () =>
  useAppSelector(
    ({ feed }: AppState) => feed.suggested?.recorded?.ids || [],
    shallowEqual,
  );

export const useMayLoadMoreSuggestedRecorded = () =>
  useAppSelector(({ feed }: AppState) =>
    feed.suggested?.recorded?.mayLoadMore !== undefined
      ? feed.suggested?.recorded?.mayLoadMore
      : true,
  );

export const useRecordedShows = (userId: string) =>
  useAppSelector(({ auth, feed }: AppState) => {
    if (userId === auth.user?.id) {
      return feed.myProfile.ids;
    } else {
      return feed.byProfileId[userId] ? feed.byProfileId[userId].ids : [];
    }
  }, shallowEqual);

export const useRecordedShowsMayLoadMore = (userId: string) =>
  useAppSelector(({ auth, feed }: AppState) => {
    if (userId === auth.user?.id) {
      return feed.myProfile.mayLoadMore;
    } else {
      return feed.byProfileId[userId]
        ? feed.byProfileId[userId].mayLoadMore
        : true;
    }
  });

export const useUserFollowingLiveShows = () =>
  useAppSelector(
    ({ feed }: AppState) => feed.following?.live?.ids || [],
    shallowEqual,
  );

export const useUserFollowingLiveShowsMayLoadMore = () =>
  useAppSelector(({ feed }: AppState) =>
    feed.following?.live?.mayLoadMore !== undefined
      ? feed.following?.live?.mayLoadMore
      : true,
  );

export const useUserFollowingRecordedShows = () =>
  useAppSelector(
    ({ feed }: AppState) => feed.following?.recorded?.ids || [],
    shallowEqual,
  );

export const useUserFollowingRecordedShowsMayLoadMore = () =>
  useAppSelector(({ feed }: AppState) =>
    feed.following?.recorded?.mayLoadMore !== undefined
      ? feed.following?.recorded?.mayLoadMore
      : true,
  );

export const useScheduledShows = () =>
  useAppSelector(
    ({ feed }: AppState) => feed.scheduled?.ids || [],
    shallowEqual,
  );

export const useScheduledShowsMayLoadMore = () =>
  useAppSelector(({ feed }: AppState) =>
    feed.scheduled?.mayLoadMore !== undefined
      ? feed.scheduled?.mayLoadMore
      : true,
  );
